module.exports = __webpack_public_path__ + "static/media/ors1.png.d18ec3f4.jpg";